module.exports = __webpack_public_path__ + "img/floor9.b50b1933.jpg";